export const firebaseConfig = {
   // Paste all this from the Firebase console...
   apiKey: "AIzaSyCWOrr40bNNP-7yWDGgdDcpfWHRd7ZGG50",
   authDomain: "abap-test-825b8.firebaseapp.com",
   databaseURL: "https://abap-test-825b8.firebaseio.com",
   projectId: "abap-test-825b8",
   storageBucket: "abap-test-825b8.appspot.com",
   messagingSenderId: "686267099123"
};



// WEBPACK FOOTER //
// C:/Users/Francesco/github/ABAPFire.app/src/environments/firebaseConfig.ts